import _ from 'lodash';
import React from 'react';
import { NavLink } from 'fluxible-router';
import { toTitleCase } from '../../lib/utils';
import config from '../../config/client';
import styles from './index.sass';

class Breadcrumbs extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
    links: React.PropTypes.arrayOf(React.PropTypes.object),
    filters: React.PropTypes.array, // Appended after links if present
    helperText: React.PropTypes.string,
    onClickFilter: React.PropTypes.func,
    hideOnMobile: React.PropTypes.bool
  };

  static defaultProps = {
    hideOnMobile: false
  };

  handleOnClickFilter(filter, e) {
    this.props.onClickFilter && this.props.onClickFilter(filter);
  }

  renderJSONLD() {
    let jsonLD = {
      "@context": "http://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": this.props.links.map((link, index) => {
        return {
          "@type": "ListItem",
          "position": index + 1,
          "item": {
            "@id": `${config.BanquetUrl}${link.href}`,
            "name": link.text
          }
        };
      })
    };
    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLD)}} />;
  }

  render() {
    let classes = styles.breadcrumbs;
    if(this.props.className) {
      classes += ` ${this.props.className}`;
    }
    if(this.props.hideOnMobile) {
      classes += ` ${styles.hideOnMobile}`;
    }

    let links = _.reduce(this.props.links, (arr, link, index) => {
      let { href, routeName, navParams, text } = link;
      let linkProps = {
        href,
        routeName,
        navParams,
        className: styles.link,
        activeClass: styles.active,
        key: href || routeName
      };
      if(!text && routeName) {
        switch(routeName) {
          case 'storeLandingPage':
            text = 'Home';
            break;
          case 'collections':
          default:
            text = _.capitalize(routeName);
            break;
        }
      }
      arr.push(<NavLink {...linkProps}>{text}</NavLink>);
      if(index !== this.props.links.length) {
        arr.push(<span className={styles.delimiter} key={index}>/</span>);
      }
      return arr;
    }, []);

    let helperText;
    if(this.props.helperText) {
      helperText = <span className={styles.helperText}>{this.props.helperText}</span>;
    }

    let filters = [];
    if(this.props.filters) {
      // filters = [<span className={styles.delimiter} key={0}>/</span>];
      filters = filters.concat(this.props.filters.map((filter, i) => {
        let text = filter.value;
        if(filter.type === 'text' || filter.type === 'tag') {
          text = toTitleCase(text.replace(/-/g, ' '));
        }
        return <button className={styles.filter} key={`${filter.type}:${filter.value}`} onClick={this.handleOnClickFilter.bind(this, filter)}>{text}</button>;
      }));
    }

    return (
      <div className={classes}>
        <ul className={styles.links}>
          {links}
          {filters}
        </ul>
        {helperText}
        {this.renderJSONLD()}
      </div>
    );
  }
}

export default Breadcrumbs;



// WEBPACK FOOTER //
// banquet/components/Breadcrumbs/index.js